import styled from "styled-components";

export const AccordBtn = styled.span`
  display: inline-flex;
  width: ${(p) => (p.btnWidth ? p.btnWidth : "2.6rem")};
  height: ${(p) => (p.btnHeight ? p.btnHeight : "2.6rem")};
  background-color: rgba(20, 24, 35, 0.1);
  border-radius: 50%;
  position: relative;
  align-items: center;
  justify-content: center;
  margin: ${(p) => (p.margin ? p.margin : "")};
  cursor: pointer;
  ::after {
    content: "";
    border: solid #898b91;
    border-width: 0 0.2rem 0.2rem 0;
    display: inline-block;
    padding: 0.3rem;
    transform: rotate(-135deg);
  }
  ${(p) =>
    !p.active &&
    `
        ::after{
            transform: rotate(45deg);
        }   
    `}
`;

export default AccordBtn;